import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, ArrowRight, TrendingUp, Trophy, Users } from 'lucide-react';

const news = [
  {
    id: 1,
    title: 'Les Tendances des Paris Sportifs en 2025',
    excerpt: 'Découvrez les sports et marchés qui génèrent le plus de gains cette année, et comment adapter votre stratégie pour maximiser vos chances de succès.',
    date: '22.11.2025',
    category: 'Stratégie',
    icon: TrendingUp,
    color: 'from-blue-600 to-blue-800',
    image: '/images/stephen-baker-QAX5Ylx-lKo-unsplash.webp',
    link: '/news/tendances-paris-sportifs-2025',
  },
  {
    id: 2,
    title: 'Nouveaux Bonus Disponibles ce Mois',
    excerpt: 'Une sélection exclusive des meilleures promotions du moment : bonus doublés, freebets, et offres spéciales pour les événements sportifs majeurs à venir.',
    date: '20.11.2025',
    category: 'Promotions',
    icon: Trophy,
    color: 'from-pink-600 to-pink-800',
    image: '/images/julia-kuzenkov-UTLqS1wa104-unsplash.webp',
    link: '/news/nouveaux-bonus-novembre',
  },
  {
    id: 3,
    title: 'Guide : Gérer son Bankroll comme un Pro',
    excerpt: 'Les techniques utilisées par les parieurs expérimentés pour préserver leur capital, éviter les mises émotionnelles et parier de manière rationnelle sur le long terme.',
    date: '18.11.2025',
    category: 'Guides',
    icon: Users,
    color: 'from-green-600 to-green-800',
    image: '/images/philippe-gras-WkvOwzndn94-unsplash.webp',
    link: '/news/gerer-bankroll-professionnel',
  },
];

const News = () => {
  return (
    <section id="actualites" className="py-20 bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Actualités & Conseils
            </h2>
            <p className="text-xl text-gray-400">
              Restez informé des dernières tendances et astuces du monde des paris
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {news.map((item, index) => {
              const Icon = item.icon;
              return (
                <article
                  key={item.id}
                  itemScope
                  itemType="https://schema.org/NewsArticle"
                  className={`bg-gray-800 rounded-xl overflow-hidden border border-gray-700 hover:border-pink-600 transition-all transform hover:-translate-y-2 flex flex-col ${
                    index === 0 ? 'md:col-span-1' : ''
                  }`}
                >
                  {/* Image */}
                  <div className="h-40 relative overflow-hidden">
                    <img 
                      src={item.image} 
                      alt={item.title} 
                      className="w-full h-full object-cover"
                    />
                    <div className={`absolute inset-0 bg-gradient-to-br ${item.color} opacity-70`}></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <Icon className="text-white opacity-40" size={64} />
                    </div>
                    <div className="absolute top-3 left-3">
                      <span className="bg-black/60 backdrop-blur-sm px-3 py-1 rounded-full text-white text-xs font-semibold">
                        {item.category}
                      </span>
                    </div>
                  </div>

                  <div className="p-6 flex-1 flex flex-col">
                    <div className="flex items-center text-gray-400 text-sm mb-3">
                      <Calendar size={14} className="mr-2" />
                      <span>{item.date}</span>
                    </div>

                    <h3 className="text-xl font-bold text-white mb-3 line-clamp-2" itemProp="headline">
                      {item.title}
                    </h3>

                    <p className="text-gray-400 text-sm mb-4 flex-1 leading-relaxed line-clamp-3" itemProp="description">
                      {item.excerpt}
                    </p>

                    <Link
                      to={item.link}
                      data-discover="true"
                      className="inline-flex items-center space-x-2 text-pink-400 hover:text-pink-300 font-semibold text-sm group"
                    >
                      <span>Lire la suite</span>
                      <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
                    </Link>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default News;

